<ul class="wrapper">
    <li class="item" *ngFor="let day of days" (click)="onClick(day)" [ngClass]="{ selected: selected.includes(day) }">
        {{ day.substring(0, 3) | appTranslateOptions: weekdayDisplayOptions }}
    </li>
</ul>
